export enum LoadManagementFilterTypeEnum {
    PROPPANT = 'Proppant',
    LOADING_FACILITY = 'Loading Facility',
    DRIVER = 'Driver',
    CARRIER = 'Carrier',
    LOAD_STATUS = 'Load Status',
    REGION = 'Region',
    DISTRICT = 'District',
    CUSTOMER = 'Customer',
    JOB_STATUS = 'Job Status',
    JOB = 'Job',
    STATUS = 'Status',
    COMPLIANT_STATUS = 'CompliantStatus',
    IS_AVAILABLE = 'IsAvailable',
    CHECKIN_WITH_BELLY_DUMP = 'CheckInWithBellyDump',
}
